module.exports = __webpack_public_path__ + "media/tph/bghead-old-a99affd5.png";